<template>
  <div>
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
import Chart from './chart.vue';
export default {
  data () {
    return {
      cdata: {
        indicatorData:['4月', '5月', '6月', '7月', '8月', '9月'],
        // seriesData1: [19,23,18,29,19,30],
        seriesData2: [2.1,1.6,2.4,2.80,3.50,1.90],
      }
    }
  },
  components: {
    Chart,
  }
}
</script>